import { useState, useEffect } from 'react';
import api from '../services/api';

export default function useAgence() {
    const [contexte, setContexte] = useState(null);

    useEffect(() => {
        if (!localStorage.getItem('token')) return;
        api.get('/agence-context')
            .then(res => setContexte(res.data))
            .catch(() => {});
    }, []);

    const changerAgence = (id) => {
        localStorage.setItem('agence_active', String(id));
        localStorage.setItem('haut_fait_petit_curieux', '1');
        window.location.reload();
    };

    return {
        agenceActive: contexte?.active || null,
        agences: contexte?.disponibles || [],
        peutChanger: contexte?.peutChanger || false,
        changerAgence,
    };
}